<div class="panel panel-default">
  <div class="panel-heading">
    {{ item.relationship_type | display:meta['relationship_type'].choices }}
  </div>
  <div class="panel-body">
            <span
              *ngFor="let key of (item.contact_contact_type === 'individual' ? contacts_display_fields : organization_display_fields)">

                <b><span
                  [innerHTML]="meta[key].label"></span></b>:
                <app-display-field [value]="item[key]"
                               [type]="meta[key].type"
                               [choices]="meta[key].choices"></app-display-field>
<!--                <b *ngIf="item.errors[key].errorMessage !== undefined"-->
<!--                   style="color: #a94442;">{{ item.errors[key].errorMessage }}</b>-->
<br/>
            </span>

  </div>
</div>
